import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

import paypalLogoBlack from '#src/assets/payment/paypal-black.png';
import paypalLogoWhite from '#src/assets/payment/paypal-white.png';

export const PayWithCreditCardOrPaypalText: React.FC = () => {
	return (
		<div className="flex justify-center text-center">
			<Text className="text-typography-secondary">
				<TranslateHtml
					value="corgi.membership.ask.pay_with"
					replacements={{
						paypalImageElement: (
							<>
								<Image
									alt="PayPal"
									className="ml-1.5 inline aspect-auto h-6 w-auto dark:hidden"
									src={paypalLogoBlack}
								/>
								<Image
									alt="PayPal"
									className="ml-1.5 hidden aspect-auto h-6 w-auto dark:inline"
									src={paypalLogoWhite}
								/>
							</>
						),
					}}
				/>
			</Text>
		</div>
	);
};
